import { useCallback, useEffect, useState } from 'react'

import { applyTheme, currentResolvedTheme, readThemeChoice, type ResolvedTheme, type ThemeChoice } from '../lib/theme'

/**
 * Menjaga pilihan tema dan tema yang berlaku. Bila pilihan mengikuti sistem,
 * perubahan `prefers-color-scheme` langsung diterapkan tanpa menyentuh pilihan
 * tersimpan.
 */
export function useTheme() {
  // Tema awal sudah dipasang /theme.js sebelum React dirender, jadi state awal
  // dibaca dari dokumen, bukan diterapkan ulang di dalam effect.
  const [choice, setChoice] = useState<ThemeChoice>(() => readThemeChoice())
  const [resolved, setResolved] = useState<ResolvedTheme>(() => currentResolvedTheme())

  useEffect(() => {
    if (choice !== 'system') {
      return
    }
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    function onSystemChange() {
      setResolved(applyTheme('system'))
    }
    media.addEventListener('change', onSystemChange)
    return () => {
      media.removeEventListener('change', onSystemChange)
    }
  }, [choice])

  const select = useCallback((next: ThemeChoice) => {
    setChoice(next)
    setResolved(applyTheme(next))
  }, [])

  return { choice, resolved, select }
}
